import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconWaiting = createIcon({
  viewBox: '0 0 48 48',
  path: (
    <>
      <path
        d="M24 39.1875C32.3878 39.1875 39.1875 32.3878 39.1875 24C39.1875 15.6122 32.3878 8.8125 24 8.8125C15.6122 8.8125 8.8125 15.6122 8.8125 24C8.8125 32.3878 15.6122 39.1875 24 39.1875Z"
        fill="#A5AAAF"
        stroke="white"
        strokeWidth="3.75"
      />
      <path
        d="M24 40.875C33.3198 40.875 40.875 33.3198 40.875 24C40.875 14.6802 33.3198 7.125 24 7.125C14.6802 7.125 7.125 14.6802 7.125 24C7.125 33.3198 14.6802 40.875 24 40.875Z"
        stroke="#A5AAAF"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7 18C24.3627 18 24.9 18.4998 24.9 19.1163V25.7064L27.8219 28.0362C28.325 28.4374 28.3833 29.1421 27.952 29.6102C27.5207 30.0782 26.7632 30.1325 26.26 29.7312L22.5 26.7333V19.1163C22.5 18.4998 23.0373 18 23.7 18Z"
        fill="white"
      />
    </>
  ),
});

export default IconWaiting;
